import api from '@/utils/api';
import {
    GET_LIST_APPOINTMENTS,
    GET_SPECIFIC_APPOINTMENT,
    UPDATE_SPECIFIC_APPOINTMENT,
    CREATE_NEW_APPOINTMENT,
    REMOVE_APPOINTMENT,
    UPDATE_SPECIFIC_APPOINTMENT_STATUS,
    TRANSFER_APPOINTMENT_TO_STAFF,
    GET_APPOINTMENT_LIST_BY_CUSTOMER,
    CHANGE_APPOINTMENT,
    APPOINTMENT_EXPORT_EXCEL,
    GET_APPOINTMENTS_STATISTICS,
} from './types';

import { NotificationManager } from 'react-notifications';

export const getListAppointments = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/appointments', { params: filter })
            .then(res => {
                dispatch({ type: GET_LIST_APPOINTMENTS, payload: res.data.data });
                resolve(res.data);
            })
            .catch(err => {
                NotificationManager.error(err?.response?.data?.msg);
                reject(err);
            });
    });
};

export const getAppointmentsStatistics = (filter) => dispatch => {
  return new Promise((resolve, reject) => {
    return api.get('/appointments/statistics', { params: filter })
      .then(res => {
        dispatch({
          type: GET_APPOINTMENTS_STATISTICS,
          payload: res.data.data || {},
        });
        resolve(res.data.data || {});
      })
      .catch(err => {
        NotificationManager.error(err?.response?.data?.msg || 'Có lỗi xảy ra');
        reject(err);
      });
  });
};

export const getSpecificAppointment = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/appointments/${id}`)
            .then(res => {
                dispatch({ type: GET_SPECIFIC_APPOINTMENT, payload: res.data.data });
                resolve(res.data.data);
            })
            .catch(err => {
                NotificationManager.error(err?.response?.data?.msg);
                reject(err);
            });
    });
};

export const createAppointment = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/appointments', data)
            .then(res => {
                dispatch({ type: CREATE_NEW_APPOINTMENT, payload: res.data.data });
                NotificationManager.success(res.data.msg);
                resolve(res.data.data);
            })
            .catch(err => {
                const res = err?.response;
                const payload = res?.data?.data;

                if (!payload?.need_confirm) {
                    NotificationManager.error(
                        res?.data?.msg || payload?.message || 'Có lỗi xảy ra'
                    );
                }

                reject(err);
            });
    });
};

export const updateAppointment = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/appointments/${id}`, data)
            .then(res => {
                dispatch({ type: UPDATE_SPECIFIC_APPOINTMENT, payload: res.data.data });
                NotificationManager.success(res.data.msg);
                resolve(res.data);
            })
            .catch(err => {
                const res = err?.response;
                const payload = res?.data?.data;

                if (!payload?.need_confirm) {
                    NotificationManager.error(
                        res?.data?.msg || payload?.message || 'Có lỗi xảy ra'
                    );
                }

                reject(err);
            });
    });
};

export const updateAppointmentStatus = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/appointments/status/${id}`, data)
            .then(res => {
                dispatch({ type: UPDATE_SPECIFIC_APPOINTMENT_STATUS, payload: res.data.data });
                NotificationManager.success(res.data.msg);
                resolve(res.data);
            })
            .catch(err => {
                NotificationManager.error(err?.response?.data?.msg);
                reject(err);
            });
    });
};

export const removeAppointment = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/appointments`, { data: { ids } })
            .then(res => {
                dispatch({ type: REMOVE_APPOINTMENT, payload: ids });
                NotificationManager.success(res.data.msg);
                resolve(res.data);
            })
            .catch(err => {
                NotificationManager.error(err?.response?.data?.msg);
                reject(err);
            });
    });
};

export const transferAppointmentToStaff = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/appointments/transfer-to-staff', data)
            .then(res => {
                dispatch({ type: TRANSFER_APPOINTMENT_TO_STAFF, payload: res.data.data });
                NotificationManager.success(res.data.msg);
                resolve(res.data.data);
            })
            .catch(err => {
                NotificationManager.error(err?.response?.data?.msg);
                reject(err);
            });
    });
};

export const getAppointmentsByCustomer = (customer_id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/appointments/customer/${customer_id}`)
            .then(res => {
                dispatch({ type: GET_APPOINTMENT_LIST_BY_CUSTOMER, payload: res.data.data });
                resolve(res.data.data);
            })
            .catch(err => {
                NotificationManager.error(err?.response?.data?.msg);
                reject(err);
            });
    });
};

export const moveAppointment = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/appointments/move', data)
            .then(res => {
                dispatch({ type: CHANGE_APPOINTMENT, payload: res.data.data });
                NotificationManager.success(res.data.msg);
                resolve(res.data.data);
            })
            .catch(err => {
                NotificationManager.error(err?.response?.data?.msg);
                reject(err);
            });
    });
};

export const exportAppointmentsExcel = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post(`/appointments/export`, filter)
            .then(res => {
                dispatch({ type: APPOINTMENT_EXPORT_EXCEL, payload: res.data.data });
                resolve(res.data.data);
            })
            .catch(err => {
                NotificationManager.error(err?.response?.data?.msg);
                reject(err);
            });
    });
};